import "./portfolio.css";
import pokemonsAppImage from "../../assets/images/Portfolio/pokemon-front.gif";
import somoscracksImage from "../../assets/images/Portfolio/somoscracks.png";
import weatherAppImage from "../../assets/images/Portfolio/WeatherApp.png";
import blackCloverTattooImage from "../../assets/images/Portfolio/BlackCloverTattoo.png";
import SvgInfo from "../../assets/icons/svgInfo";
import SvgOpenWindow from "../../assets/icons/svgOpenWindow";
import SvgGitHub from "../../assets/icons/svgGitHub";
import { useSelector } from "react-redux";
import HTML from "../../assets/images/HTML.svg.png";
import CSS from "../../assets/images/CSS3_logo.svg.png";
import JS from "../../assets/images/JS.png";
import TS from "../../assets/images/TS.png";
import React from "../../assets/images/React-icon.svg.png";
import Redux from "../../assets/images/redux.png";
import ReactNative from "../../assets/images/ReactNative.jpg";
import Next from "../../assets/images/next.png";
import Node from "../../assets/images/node.png";
import Express from "../../assets/images/express.png";
import Postgre from "../../assets/images/postgreSQL.png";
import MySQl from "../../assets/images/mysql.png";
import Sequelize from "../../assets/images/sequelize.png";
import Primsa from "../../assets/images/prisma.png";
import Tailwind from "../../assets/images/tailwind.png";
import Bootstrap from "../../assets/images/bootstrap.png";
import SASS from "../../assets/images/sass.png";
import Git from "../../assets/images/git.png";
import Github from "../../assets/images/github.png";
import Figma from "../../assets/images/figma.png";
import Pyhton from "../../assets/images/python.png";
import Photoshop from "../../assets/images/photoshop.png";
import Scrum from "../../assets/images/scrum.png";
import SEO from "../../assets/images/SEO.png";
import SQLite from "../../assets/images/sqlite.png";
import Postman from "../../assets/images/postman.png";
import Jest from "../../assets/images/jest.png";
import JQuery from "../../assets/images/JQuery.png";
import Angular from "../../assets/images/Angular.png";
import Vue from "../../assets/images/Vue.png";
import PHP from "../../assets/images/php.png";
import Csharp from "../../assets/images/Csharp.png";
import Wordpress from "../../assets/images/Wordpress.png";
import Shopify from "../../assets/images/shopify.png";
import Mongodb from "../../assets/images/Mongodb.png";

export default function Projects() {
  interface AppState {
    lenguage: string;
  }

  let { lenguage } = useSelector((state: AppState) => state);

  return (
    <div className="bigPortfolioContainer">
      {lenguage === "english" ? (
        <div className="portfolioTextContainer animate__animated animate__fadeInLeft">
          <h2>Portfolio</h2>
          <p>My Projects:</p>
        </div>
      ) : (
        <div className="portfolioTextContainer animate__animated animate__fadeInLeft">
          <h2>Portafolio</h2>
          <p>Mis Proyectos:</p>
        </div>
      )}

      <div className="portfolioContainerPositionBox animate__animated animate__fadeInRight">
        <div className="portfolioContainer">
          <div className="projectContainer">
            <img
              src={somoscracksImage}
              alt="Dogs App Oleydi Peña"
              className="projectImage"
            />
            <div className="projectInfo">
              <div className="mainProjectInfo">
                <div className="projectTitleContainer">
                  <h3>SOMOS CRACKS</h3>
                </div>
                <div className="techs">
                    <img src={HTML} alt="HTML Logo" className="techsIcons" />
                    <img src={CSS} alt="CSS Logo" className="techsIcons" />
                    <img
                      src={JS}
                      alt="JavaScript Logo"
                      className="techsIcons"
                    />
                    <img src={React} alt="React Logo" className="techsIcons" />
                    <img src={Redux} alt="Redux Logo" className="techsIcons" />
                    <img src={Node} alt="Nodejs Logo" className="techsIcons" />
                    <img
                      src={Express}
                      alt="Express Logo"
                      className="techsIcons"
                    />
                    <img src={Postgre} alt="PostgreSQL Logo" className="techsIcons" />
                  </div>
                <div className="projectInfoContainer">
                  <a
                    href="https://somoscracks.vercel.app"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Deploy</p>
                      <SvgOpenWindow className="projectInfoIcon" />
                    </div>
                  </a>
                  <a href="#" target={"_blank"} rel="noreferrer">
                    <div className="projectLinkContainer">
                      <p>Info</p>
                      <SvgInfo className="projectInfoIcon" />
                    </div>
                  </a>
                  <a
                    href="#private"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Github</p>
                      <SvgGitHub className="projectInfoIcon" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="projectContainer">
            <img
              src={pokemonsAppImage}
              alt="Pokemons App Oleydi Peña"
              className="projectImage"
            />
            <div className="projectInfo">
              <div className="mainProjectInfo">
                <div className="projectTitleContainer">
                  <h3>Pokemon App</h3>
                </div>
                <div className="techs">
                    <img src={HTML} alt="HTML Logo" className="techsIcons" />
                    <img src={CSS} alt="CSS Logo" className="techsIcons" />
                    <img
                      src={JS}
                      alt="JavaScript Logo"
                      className="techsIcons"
                    />
                    <img src={React} alt="React Logo" className="techsIcons" />
                    <img src={Redux} alt="Redux Logo" className="techsIcons" />
                    <img src={Node} alt="Nodejs Logo" className="techsIcons" />
                    <img
                      src={Express}
                      alt="Express Logo"
                      className="techsIcons"
                    />
                    <img src={Postgre} alt="PostgreSQL Logo" className="techsIcons" />
                  </div>
                <div className="projectInfoContainer">
                  <a
                    href="https://pokemon-front-theta.vercel.app"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Deploy</p>
                      <SvgOpenWindow className="projectInfoIcon" />
                    </div>
                  </a>
                  <a href="#" target={"_blank"} rel="noreferrer">
                    <div className="projectLinkContainer">
                      <p>Info</p>
                      <SvgInfo className="projectInfoIcon" />
                    </div>
                  </a>
                  <a
                    href="https://github.com/oleydi1234/PI-Pokemon"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Github</p>
                      <SvgGitHub className="projectInfoIcon" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="projectContainer">
            <img
              src={weatherAppImage}
              alt="Dogs App Oleydi Peña"
              className="projectImage"
            />
            <div className="projectInfo">
              <div className="mainProjectInfo">
                <div className="projectTitleContainer">
                  <h3>Weather App</h3>
                </div>
                <div className="techs">
                    <img src={HTML} alt="HTML Logo" className="techsIcons" />
                    <img src={CSS} alt="CSS Logo" className="techsIcons" />
                    <img
                      src={JS}
                      alt="JavaScript Logo"
                      className="techsIcons"
                    />
                    <img src={React} alt="React Logo" className="techsIcons" />
                    <img src={Redux} alt="Redux Logo" className="techsIcons" />
                    <img src={Node} alt="Nodejs Logo" className="techsIcons" />
                    <img
                      src={Express}
                      alt="Express Logo"
                      className="techsIcons"
                    />
                    <img src={Postgre} alt="PostgreSQL Logo" className="techsIcons" />
                  </div>
                <div className="projectInfoContainer">
                  <a
                    href="https://pokemon-front-theta.vercel.app"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Deploy</p>
                      <SvgOpenWindow className="projectInfoIcon" />
                    </div>
                  </a>
                  <a href="#" target={"_blank"} rel="noreferrer">
                    <div className="projectLinkContainer">
                      <p>Info</p>
                      <SvgInfo className="projectInfoIcon" />
                    </div>
                  </a>
                  <a
                    href="https://github.com/oleydi1234/PI-Pokemon"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Github</p>
                      <SvgGitHub className="projectInfoIcon" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="projectContainer">
            <img
              src={blackCloverTattooImage}
              alt="Dogs App Oleydi Peña"
              className="projectImage"
            />
            <div className="projectInfo">
              <div className="mainProjectInfo">
                <div className="projectTitleContainer">
                  <h3>Black Clover Tattoo</h3>
                </div>
                <div className="techs">
                    <img src={HTML} alt="HTML Logo" className="techsIcons" />
                    <img src={CSS} alt="CSS Logo" className="techsIcons" />
                    <img
                      src={JS}
                      alt="JavaScript Logo"
                      className="techsIcons"
                    />
                    <img src={React} alt="React Logo" className="techsIcons" />
                    <img src={Redux} alt="Redux Logo" className="techsIcons" />
                    <img src={Node} alt="Nodejs Logo" className="techsIcons" />
                    <img
                      src={Express}
                      alt="Express Logo"
                      className="techsIcons"
                    />
                    <img src={Postgre} alt="PostgreSQL Logo" className="techsIcons" />
                  </div>
                <div className="projectInfoContainer">
                  <a
                    href="https://pokemon-front-theta.vercel.app"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Deploy</p>
                      <SvgOpenWindow className="projectInfoIcon" />
                    </div>
                  </a>
                  <a href="#" target={"_blank"} rel="noreferrer">
                    <div className="projectLinkContainer">
                      <p>Info</p>
                      <SvgInfo className="projectInfoIcon" />
                    </div>
                  </a>
                  <a
                    href="https://github.com/oleydi1234/PI-Pokemon"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <div className="projectLinkContainer">
                      <p>Github</p>
                      <SvgGitHub className="projectInfoIcon" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
